<template>
  <div>
    <v-container fluid class="px-6 py-6">
      <v-row>
        <v-col lg="12" cols="12">
          <v-row>
           
            <v-col cols="12">
              <v-card class="bg-gradient-primary border-radius-xl">
                <div class="px-4 py-4">
                  <v-row class="row">
                    <v-col cols="8" class="my-auto">
                      <div class="numbers">
                        <p
                          class="
                            text-white text-sm
                            mb-3
                            text-capitalize
                            font-weight-bold
                            opacity-7
                          "
                        >
                          {{ user.company }}
                        </p>
                        <h5 class="text-white text-h5 font-weight-light mb-1">
                          Total Locations - 7
                        </h5>
                        <h5 class="text-white text-h6 font-weight-light mb-0">
                          Total Sensors - 2800
                        </h5>
                      </div>
                    </v-col>
                    <v-col cols="4" class="text-end">
                      <h5 class="mb-0 text-white text-h5 text-end me-1">
                        <strong> 8 </strong> alerts in the last 24 hours
                      </h5>
                    </v-col>
                  </v-row>
                </div>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row>
        <v-col lg="12">
          <v-card class="card-shadow border-radius-xl">
            <div class="pb-0 px-4 pt-4">
              <div class="d-flex align-items-center">
                <h6 class="text-h6 text-typo mb-0 font-weight-bold">
                  Consumption by location
                </h6>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      small
                      rounded
                      v-bind="attrs"
                      v-on="on"
                      min-width="25"
                      elevation="0"
                      :ripple="false"
                      height="25"
                      width="25"
                      class="
                        font-weight-600
                        text-capitalize
                        btn-outline-secondary
                        py-3
                        px-4
                        ms-auto
                      "
                      color="transparent"
                    >
                      <v-icon size="8">fas fa-info</v-icon>
                    </v-btn>
                  </template>
                  <span>See the consumption per location</span>
                </v-tooltip>
              </div>
            </div>
            <div class="px-4 py-4">
              <v-row>
                <v-col cols="5" class="text-center position-relative">
                  <div class="chart">
                    <canvas
                      id="chart-consumption"
                      class="chart-canvas"
                      height="225"
                    ></canvas>
                  </div>
                  <div class="mt-n16 ms-n3 position-absolute w-100">
                    <h4 class="font-weight-bold text-h4 text-typo mt-n16">
                      <span>471.3</span>
                      <span class="d-block text-body text-sm">WATTS</span>
                    </h4>
                  </div>
                </v-col>
                <v-col cols="7">
                  <v-simple-table class="table" height="100%">
                    <template v-slot:default>
                      <tbody>
                        <tr v-for="(i, index) in locations" :key="index">
                          <td>
                            <div class="d-flex px-2 py-0">
                              <div
                                class="
                                  d-flex
                                  flex-column
                                  justify-content-center
                                "
                              >
                                <h6
                                  class="
                                    mb-0
                                    text-sm text-typo
                                    font-weight-bold
                                  "
                                >
                                  {{ i.name }}
                                </h6>
                              </div>
                            </div>
                          </td>
                          <td class="align-middle text-center text-sm">
                            <span class="text-xs font-weight-bold text-body">
                              {{ i.value * 100 }}%
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-col>
              </v-row>
            </div>
          </v-card>
        </v-col>
        <v-col lg="12">
          <v-row>
            <v-col sm="6">
              <v-card class="h-100 card-shadow border-radius-xl">
                <div class="px-4 py-4">
                  <h6 class="text-h6 text-typo font-weight-bold">
                    Consumption per day
                  </h6>
                  <div class="chart pt-4">
                    <canvas
                      id="chart-cons-week"
                      class="chart-canvas"
                      height="170"
                    ></canvas>
                  </div>
                </div>
              </v-card>
            </v-col>
            <v-col sm="6">
              <v-card class="card-shadow border-radius-xl">
                <div class="px-4 py-4">
                  <h6 class="text-h6 text-typo font-weight-bold">
                    Sensor Alerts
                  </h6>
                  <div class="text-center mt-4">
                    <round-slider
                      class="d-flex justify-center mx-auto"
                      v-model="sliderValue"
                      min="0"
                      max="2800"
                      width="6"
                      borderColor="#a12220"
                      pathColor="#d3d3d3"
                      rangeColor="#a12220"
                      tooltipColor="#344767"
                      handleSize="20"
                      start-angle="315"
                      end-angle="+270"
                      line-cap="round"
                      radius="80"
                    />
                    <p class="ps-1 mt-2 mb-0 text-body">
                      <span class="px-3"
                        >{{ ((202 / 2800) * 100).toFixed(0) }}% Needs
                        Attention</span
                      >
                    </p>
                  </div>
                </div>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import RoundSlider from "vue-round-slider";

export default {
  name: "smart-home",
  components: {
    RoundSlider,
  },
  data() {
    return {
      tab: null,
      chartConsumption: "chart-consumption",
      chartConsWeek: "chart-cons-week",
      switche: false,
      switch1: true,
      switch2: true,
      switch3: false,
      switch4: false,
      switch5: true,
      sliderValue: "202",
      locations: [
        {
          id: 1,
          name: "Facility 1",
          sensorCount: 400,
          city: "Dallas",
          state: "TX",
          alerts: 1,
          value: 0.1,
        },
        {
          id: 2,
          name: "Facility 2",
          sensorCount: 600,
          city: "Sulpher Springs",
          state: "TX",
          alerts: 0,
          value: 0.2,
        },
        {
          id: 3,
          name: "Facility 3",
          sensorCount: 200,
          city: "Atlanta",
          state: "GA",
          alerts: 7,
          value: 0.05,
        },
        {
          id: 4,
          name: "Facility 4",
          sensorCount: 1000,
          city: "College Station",
          state: "TX",
          alerts: 0,
          value: 0.5,
        },
        {
          id: 5,
          name: "Facility 5",
          sensorCount: 200,
          city: "Atlanta",
          state: "GA",
          alerts: 0,
          value: 0.05,
        },
        {
          id: 6,
          name: "Facility 6",
          sensorCount: 200,
          city: "Atlanta",
          state: "GA",
          alerts: 0,
          value: 0.05,
        },
        {
          id: 7,
          name: "Facility 7",
          sensorCount: 200,
          city: "Atlanta",
          state: "GA",
          alerts: 0,
          value: 0.05,
        },
      ],
    };
  },
  computed: {
    user() {
      return this.$store.state.auth;
    },
  },
  mounted() {
    new Chart(document.getElementById(this.chartConsumption).getContext("2d"), {
      type: "doughnut",
      data: {
        labels: [
          "Location 1",
          "Location 2",
          "Location 3",
          "Location 4",
          "Location 5",
          "Location 6",
          "Location 7",
        ],

        datasets: [
          {
            label: "Consumption",
            weight: 9,
            cutout: 90,
            tension: 0.9,
            pointRadius: 2,
            borderWidth: 2,
            backgroundColor: [
              "#FF0080",
              "#A8B8D8",
              "#21d4fd",
              "#98ec2d",
              "#ff667c",
            ],
            data: [15, 20, 13, 32, 20],
            fill: false,
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false,
          },
        },
        interaction: {
          intersect: false,
          mode: "index",
        },
        scales: {
          y: {
            grid: {
              drawBorder: false,
              display: false,
              drawOnChartArea: false,
              drawTicks: false,
            },
            ticks: {
              display: false,
            },
          },
          x: {
            grid: {
              drawBorder: false,
              display: false,
              drawOnChartArea: false,
              drawTicks: false,
            },
            ticks: {
              display: false,
            },
          },
        },
      },
    });

    new Chart(document.getElementById(this.chartConsWeek).getContext("2d"), {
      type: "bar",
      data: {
        labels: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
        datasets: [
          {
            label: "Watts",
            tension: 0.4,
            borderWidth: 0,
            borderRadius: 4,
            borderSkipped: false,
            backgroundColor: "#3A416F",
            data: [150, 230, 380, 220, 420, 200, 70],
            maxBarThickness: 6,
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false,
          },
        },
        interaction: {
          intersect: false,
          mode: "index",
        },
        scales: {
          y: {
            grid: {
              drawBorder: false,
              display: false,
              drawOnChartArea: true,
              drawTicks: false,
              borderDash: [5, 5],
            },
            ticks: {
              display: true,
              padding: 10,
              color: "#9ca2b7",
            },
          },
          x: {
            grid: {
              drawBorder: false,
              display: true,
              drawOnChartArea: true,
              drawTicks: false,
              borderDash: [5, 5],
            },
            ticks: {
              display: true,
              padding: 10,
              color: "#9ca2b7",
            },
          },
        },
      },
    });
  },
};
</script>